class ProductSalesLog {
	constructor(amount, price) {
		this.amount = amount;
		this.price = price;
	}

	toPlainObj() {
		return {
			amount: this.amount,
			price: this.price
		};
	}
};

export default function ProductSalesLogBuilder() {
	return {
		withAmount: function (amount) {
			this.amount = amount;
			return this;
		},
		withPrice: function (price) {
			this.price = price;
			return this;
		},
		build: function () {
			return new ProductSalesLog(this.amount, this.price);
		}
	};
}
